import {Component, h, Host, Prop} from "@stencil/core";
import {TrustLevels as tls} from "../../types";
import {isAllowedTrustLevel} from "../../helper";

@Component({
  tag: "c-trust-level",
  styleUrl: "./styles.scss",
  shadow: true,
})
export class TrustLevel {

  @Prop({ reflect: true }) showText = false;
  @Prop({ reflect: true }) level: string; //'UNTERGEORDNET' | 'EIDAS_NIEDRIG' | 'EIDAS_SUBSTANZIELL' | 'EIDAS_HOCH';
  @Prop({ reflect: true }) requiredTrustLevel?: string;
  @Prop({ reflect: true }) hideOnAllowed?: boolean = false;
  // "meta" texts in selected language
  @Prop({ mutable: true }) i18n;

  render() {
    const level = this.level.toUpperCase();
    const requiredLevel = this.requiredTrustLevel? this.requiredTrustLevel.toUpperCase(): '';
    // if this.requiredTrustLevel not set, then allowed (=Trust Level from user is allowed to the shown level)
    const isAllowed = requiredLevel.length? isAllowedTrustLevel(requiredLevel, level): true;
    const hostClass = isAllowed? '': 'not-trusted';

    if(isAllowed && this.hideOnAllowed) { // used when only error message is needed
      return null;
    }

    return (
      <Host class={hostClass}>
        {level === tls.UNTERGEORDNET && <c-icon name="lockOpen"></c-icon>}
        {level === tls.NIEDRIG && <c-icon name="shieldLow"></c-icon>}
        {level === tls.SUBSTANZIELL && <c-icon name="shieldSubstantial"></c-icon>}
        {level === tls.HOCH && <c-icon name="shieldFull"></c-icon>}

        {isAllowed && this.showText && level === tls.UNTERGEORDNET && <span>{this.i18n?.trustlevel?.trustlevel}: {this.i18n?.trustlevel?.trustlevel_untergeordnet}</span>}
        {isAllowed && this.showText && level === tls.NIEDRIG && <span>{this.i18n?.trustlevel?.trustlevel}: {this.i18n?.trustlevel?.trustlevel_eidas_niedrig}</span>}
        {isAllowed && this.showText && level === tls.SUBSTANZIELL && <span>{this.i18n?.trustlevel?.trustlevel}: {this.i18n?.trustlevel?.trustlevel_eidas_substanziell}</span>}
        {isAllowed && this.showText && level === tls.HOCH && <span>{this.i18n?.trustlevel?.trustlevel}: {this.i18n?.trustlevel?.trustlevel_eidas_hoch}</span>}
        {!isAllowed && <span>{this.i18n?.trustlevel?.trustlevelInsufficient}</span>}
      </Host>
    );
  }
}
